import { TechnologiesConditionTypeEnum } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";
import { TechnologySignalTechnologiesFiltersKey } from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFiltersKey";

export const entryToFilterTypeMap: Record<TechnologiesConditionTypeEnum, TechnologySignalTechnologiesFiltersKey> = {
    [TechnologiesConditionTypeEnum.Category]: TechnologySignalTechnologiesFiltersKey.TechnologyCategories,
    [TechnologiesConditionTypeEnum.SubCategory]: TechnologySignalTechnologiesFiltersKey.TechnologySubCategories,
    [TechnologiesConditionTypeEnum.Technology]: TechnologySignalTechnologiesFiltersKey.Technologies,
};

export const filterToEntryTypeMap: Record<TechnologySignalTechnologiesFiltersKey, TechnologiesConditionTypeEnum> = {
    [TechnologySignalTechnologiesFiltersKey.TechnologyCategories]: TechnologiesConditionTypeEnum.Category,
    [TechnologySignalTechnologiesFiltersKey.TechnologySubCategories]: TechnologiesConditionTypeEnum.SubCategory,
    [TechnologySignalTechnologiesFiltersKey.Technologies]: TechnologiesConditionTypeEnum.Technology,
};
